import { Navigator } from "../../main_components/navigator.js";
import Styles from "./courses.module.css";
import { Courses, CoursesHeader } from "./courses_components.js";
import test1Img from "../../images/11905945_4857949.jpg";
import test2Img from "../../images/88805032_DJV MAR 1045-01.jpg";
import test3Img from "../../images/66243604_9603059.jpg";
import { useState } from "react";
export const CoursesBody = ( props ) => {
    const { } = props;
    const { Body, Content } = Styles;
    const [ filter, setFilter] = useState("All");
    const courses = [
        { image: test1Img, imageTheme: "#ffc107", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#607d8b", link: "/courses/view_course", category: "programming" },
        { image: test2Img, imageTheme: "#009688", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#795548", link: "/courses/view_course", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#ff9800", link: "/courses/view_course", category: "courses" },
        { image: test1Img, imageTheme: "#ffc107", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#607d8b", link: "/courses/view_course", category: "programming" },
        { image: test2Img, imageTheme: "#009688", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#795548", link: "/courses/view_course", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#ff9800", link: "/courses/view_course", category: "courses" },
        { image: test1Img, imageTheme: "#ffc107", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#607d8b", link: "/courses/view_course", category: "programming" },
        { image: test2Img, imageTheme: "#009688", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#795548", link: "/courses/view_course", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", clipsNumber: "12ep", clipsTime: "4hrs", cost: "FREE", name: "Test Medium", nameTheme: "#ff9800", link: "/courses/view_course", category: "courses" },
    
    ];
    const headlines = [
        "Explore Our Courses!",
        "Discover Our Learning Opportunities!",
        "Explore Our Course Catalog!",
        "Dive into Our Courses Today!",
        "Explore Our Diverse Courses!"
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Courses" }/>
            <main className={ Content }>
                <CoursesHeader 
                    setFilter = { setFilter }
                    headlines = { headlines }
                />
                <Courses
                    courses = { courses.reverse() }
                    filter={ filter }
                />
            </main>
        </main>
    );
};